import React, { useEffect, useState } from "react";
import InputText from "../../../components/input/inputText";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import Navigation from "../../../components/navigation";
import SecondScreen from "../../SecondScreen";
import { linkStep, navigationStep } from "../../../redux/slices/navigation";
import { preloaderToggle } from "../../../redux/slices/preloader";
import StepCustomize from "../../../components/stepCustomize";
import { GetQrLink } from "../../../redux/requests/link";
import QrTitleField from "../../../components/input/qrTitleField";
import axios from "axios";
import { isNoEditRoute } from "../../../hooks/helpers";
import { setCategory } from "../../../redux/slices/selectCategories";
import Form from "react-bootstrap/Form";
import { SelectCategory } from "../../../components";
import PopoverBtn from "../../../components/popoverBtn";
import useIsNoIframe from "../../../hooks/useIsNoIframe";
import useGetDataError from "../../../hooks/useGetDataError";
import useCurrentLocation from "../../../hooks/useCurrentLocation";
import { MAX_LINK_LENGTH } from "../../../constants/inputValues";
import { noEmojiPattern, validLinkPattern } from "../../../RegExpValidations";
import { saveValueLink } from "../../../redux/slices/saveValue";
import { QrBarcode, QrBarcodeEdit } from "../../../redux/requests/barcode";

function BarcodeQrWrapper({ children }) {
  const {
    lang,
    errorMsg,
    valueLink,
    getQrLinkSliceId,
    categoryChange,
    getQrLinkSliceLink,
    getQrLinkSliceError,
  } = useSelector((state) => ({
    lang: state.changeLang.language.stepTwo,
    errorMsg: state.changeLang.language.stepTwo.errors,
    valueLink: state.saveValue.valueLink,
    getQrLinkSliceId: state.getQrLinkSlice.id,
    categoryChange: state.categories.categoryChange,
    type: state.typeCard.type,
    getQrLinkSliceLink: state.getQrLinkSlice.link,
    getQrLinkSliceError: state.getQrLinkSlice.error,
  }));

  const { id } = useParams();
  let url = window.location.search.includes("?url=")
    ? window.location.search.slice(5, window.location.search.length)
    : "";

  const dispatch = useDispatch();
  let navigate = useNavigate();
  const { isNoIframe, goToLink } = useIsNoIframe();
  const { checkErrorStatus } = useGetDataError();
  const { adminEntryLocation } = useCurrentLocation();
  const [typeBarcode, setTypeBarcode] = useState(1);
  const [qrTitle, setQrTitle] = useState(valueLink[1]);
  const [validLink, setValidLink] = useState(false);
  const [link, setLink] = useState("");
  const [gtinCode, setGtinCode] = useState("");
  const [empty, setEmpty] = useState(false);
  const [error, setError] = useState("");
  useEffect(() => {
    if (id) {
      axios
        .get(`/barcode/get/${id}`)
        .then(({ data }) => {
          data[0]?.link && setLink(data[0].link);
          setValidLink(!!data[0]?.link);
          setQrTitle(data.qrTitle);
          setGtinCode(data[0]?.gtinCode);
          setTypeBarcode(data[0]?.type);
          dispatch(setCategory(data.adsCategories));
        })
        .catch((err) => {
          checkErrorStatus(err.response.status);
        });
    }
  }, [id]);

  function handleLink(e) {
    let string = e.target.value.trim();
    if (noEmojiPattern.test(string) && validLinkPattern.test(string)) {
      setValidLink(true);
      if (!/^.+:\/\//.test(string)) {
        string = `http://${string}`;
      }
    } else {
      setValidLink(false);
    }
    setLink(string);
  }

  function step() {
    if (!!link && link.length > 3 && validLink) {
      setEmpty(false);
      dispatch(preloaderToggle(true));
      if (!getQrLinkSliceId && !id) {
        dispatch(
          GetQrLink(() =>
            QrBarcode([link, categoryChange, qrTitle, gtinCode, typeBarcode])
          )
        );
      } else {
        dispatch(
          GetQrLink(() =>
            QrBarcodeEdit([
              getQrLinkSliceId || id,
              link,
              categoryChange,
              qrTitle,
              gtinCode,
              typeBarcode
            ])
          )
        ).then(() => {
          if (!isNoEditRoute) {
            window.location.href = adminEntryLocation;
          }
        });
      }

      if (isNoEditRoute) {
        dispatch(navigationStep(3));
        dispatch(saveValueLink([link, qrTitle, gtinCode]));
        isNoIframe && navigate("/qr");
      } else {
        dispatch(preloaderToggle(true));
      }
    } else {
      setEmpty(true);
    }
  }

  useEffect(() => {
    setLink(valueLink[0]);
    setValidLink(validLinkPattern.test(valueLink[0]?.trim(" ")));
    if (!!url) {
      setLink(url);
      setValidLink(true);
      dispatch(QrBarcode([url, categoryChange, true]));
      step();
    }
  }, []);

  useEffect(() => {
    if (!!link && link.length > 3 && validLink) {
      dispatch(linkStep(true));
    } else {
      dispatch(linkStep(false));
    }
  }, [link, validLink]);

  useEffect(() => {
    if (!isNoIframe && getQrLinkSliceLink) {
      goToLink();
    }
  }, [getQrLinkSliceLink]);
  const handleChangeGtin = (e) => {
    const value = e.target.value.replace(/\D/g, "");
    setGtinCode(value);
    const validLengths = [8, 12, 13, 14];
    if (value && !validLengths.includes(value.length)) {
      setError(lang.barcode[7]);
    } else {
      setError("");
    }
  };

  return (
    <>
      <Navigation />
      <SecondScreen>
        <Form className="col-12 col-lg-6 mx-auto mb-4">
          <InputText
            type="text"
            placeholder={lang.barcode[2]}
            value={gtinCode}
            onChange={handleChangeGtin}
          />
          {error && <div className="text-danger">{error}</div>}
        </Form>
        <div className="col-12 col-lg-6 mx-auto mb-4">
          <p className="fs-5 fw-bold">{lang.barcode[3]}</p>
          <div className="form-check mb-2">
            <input
              className="form-check-input"
              type="radio"
              name="barcode"
              id="barcodeLink"
              checked={typeBarcode === 1}
              onChange={() => setTypeBarcode(1)}
            />
            <label className="form-check-label" htmlFor="barcodeLink">
              {lang.barcode[4]}
            </label>
            <div className="d-inline-block ms-2">
              <PopoverBtn text={lang.barcode[5]} />
            </div>
          </div>
          <div className="form-check">
            <input
              className="form-check-input"
              type="radio"
              name="barcode"
              id="barcodeText"
              checked={typeBarcode === 2}
              onChange={() => setTypeBarcode(2)}
            />
            <label className="form-check-label" htmlFor="barcodeText">
              {lang.barcode[6]}
            </label>
            <div className="d-inline-block ms-2">
              <PopoverBtn text={lang.barcode[7]} />
            </div>
          </div>
        </div>
        <Form className="col-12 col-lg-6 mx-auto">
          <InputText
            type="link"
            placeholder={lang.barcode[0]}
            value={link || ""}
            onChange={handleLink}
            error={
              !!getQrLinkSliceError ||
              (!validLink && link?.length > 0) ||
              (empty && link?.length < 4) ||
              link?.length > MAX_LINK_LENGTH
            }
            valid={
              validLink && link?.length > 0 && link?.length <= MAX_LINK_LENGTH
            }
          >
            <>
              {!validLink && link.length > 0 && link.length < 4 && (
                <Form.Text className="text-danger">{lang.link[22]}</Form.Text>
              )}
              {!validLink && link.length >= 4 && (
                <Form.Text className="text-danger">
                  {lang.link[2]}: https://me-qr.com/
                </Form.Text>
              )}
              {empty && link?.length === 0 && !validLink && (
                <Form.Text className="text-danger">{lang.linkEmpty}</Form.Text>
              )}
              {link?.length > MAX_LINK_LENGTH && (
                <Form.Text className="text-danger">{errorMsg[0]}</Form.Text>
              )}
            </>
          </InputText>
          <QrTitleField
            value={qrTitle}
            onChange={(e) => setQrTitle(e.target.value)}
          />
        </Form>
        <SelectCategory />
        <StepCustomize
          emulate={step}
          disabled={
            !validLink ||
            link?.length > MAX_LINK_LENGTH ||
            gtinCode?.length < 8 ||
            gtinCode?.length > 14
          }
        />
      </SecondScreen>
      {isNoIframe && isNoEditRoute && children}
    </>
  );
}

export default BarcodeQrWrapper;